module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/text_white-c9a01519cf182574e1fd72011e26ba04.png";